module.exports = __webpack_public_path__ + "static/media/front.5bcdd610.jpg";